module.exports = __webpack_public_path__ + "static/img/tv-jpg.14b516b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tv-jpg.png
// module id = 8xRX
// module chunks = 1